import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ShoppingBagIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m5.12 1.62-2.5 3.34v11.67c0 .92.75 1.67 1.67 1.67h11.67c.92 0 1.67-.75 1.67-1.67V4.96l-2.5-3.33H5.12v-.01Zm-2.5 3.34h15"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M13.46 8.29c0 1.84-1.49 3.33-3.33 3.33S6.8 10.13 6.8 8.29"
      />
    </Icon>
  );
}
